import { Modal } from '@mantine/core';

export function NewPlaylistModal() {
  return (
    <Modal opened={false} onClose={() => {}}>
      Hi
    </Modal>
  );
}
